module.exports = __webpack_public_path__ + "img/0Q3A3733_L_Black.7e01f44d.jpg";